(ns livefeed.tunnus
  (:require [livefeed.state :as state]
            [livefeed.util :refer [querystring->map]]))

(defn- internal-tunnus? []
  (= "true" (some-> js/window .-location .-search querystring->map :internalTunnus)))

(defn login! []
  (let [^js tunnus @state/tunnus
        ^js yle-native (some-> js/window .-yleNative)
        ^js internal-tunnus (internal-tunnus?)
        iframe? (= "true" (some-> js/window .-location .-search querystring->map :iframe))]
    (cond
      iframe?
      (. js/parent postMessage "login" "*")

      (and yle-native (not internal-tunnus))
      (.sendCommand yle-native "login" nil)

      tunnus
      (.logIn tunnus)

      :else
      (js/console.log "[login] Tunnus SDK has not been initialized"))))

(defn require-nick! []
  (let [^js tunnus @state/tunnus
        ^js internal-tunnus (internal-tunnus?)
        ^js yle-native (some-> js/window .-yleNative)]
    (cond
      (and yle-native (not internal-tunnus))
      (.sendCommand yle-native "requireNick" nil)

      tunnus
      (.requireNick tunnus)

      :else
      (js/console.log "[requireNick] Tunnus SDK has not been initialized"))))
